import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  InformativaAziendale,
  InformativaAziendaleService,
} from 'src/app/services/informativa-aziendale/informativa-aziendale.service';
import { ReportVsmeService } from 'src/app/services/report-vsme/report-vsme.service';
import { TemaService } from 'src/app/services/tema/tema.service';

@Component({
  selector: 'app-informativa-aziendale-esterna',
  templateUrl: './informativa-aziendale-esterna.component.html',
  styleUrls: ['./informativa-aziendale-esterna.component.scss'],
  standalone: false,
})
export class InformativaAziendaleEsternaComponent implements AfterViewInit, OnInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public logoPath: string = 'assets/images/logo/logo-sostenibile.png';
  public completato: boolean = false;
  public temporaryToken!: string;
  public descrizione: string = '';
  public messaggio: string = '';

  public infoAz!: InformativaAziendale;
  public infoAzVuota: boolean = false;
  public loading = true;

  public tipoModulo: 'BILANCIO' | 'REPORT_VSME' | undefined = undefined;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly informativaAziendale: InformativaAziendaleService,
    private readonly temaService: TemaService,
  ) {
    this.temaService.temaUpdated.subscribe((tipoInstallazione) => {
      this.logoPath = temaService.logoPath;
    });
  }

  ngAfterViewInit(): void {
    this.parametriDaURL();
  }

  ngOnInit(): void {
    this.tipoModulo = this.route.snapshot.data['tipoModulo'];
  }

  /**
   * Metodo che mi prende il token dal URL
   */
  public parametriDaURL() {
    // Sottoscrivi all'observable paramMap per ottenere i parametri dall'URL
    this.spinnerOver.show();
    this.route.queryParams.subscribe((params) => {
      // Ora puoi accedere ai parametri come segue
      this.temporaryToken = params['temporaryToken'];

      if (this.temporaryToken) {
        this._getSurveyByTemporaryToken();
      } else {
        this.spinnerOver.hide();
      }
    });
  }

  /**
   * Metodo che mi prende i dati della survey dal token
   */
  private _getSurveyByTemporaryToken() {
    let service: any;
    switch (this.tipoModulo) {
      case 'BILANCIO':
        service = this.informativaAziendale.getInformativaAziendaleEsterna(this.temporaryToken);
        break;
      case 'REPORT_VSME':
        service = this.informativaAziendale.getInformativaAziendaleEsternaVsme(this.temporaryToken);
        break;

      default:
        break;
    }

    this.messaggio = '';
    service.subscribe({
      next: (esito: any) => {
        this.infoAz = esito;

        this.infoAzVuota = false;

        this.spinnerOver.hide();

        this.loading = false;
      },
      error: (err: any) => {
        console.error(err);

        this.messaggio = err?.error?.message;

        if (!this.messaggio) {
          this.messaggio = 'Nessun dato trovato';
        }
        this.infoAzVuota = true;
        this.loading = false;
        this.spinnerOver.hide();
      },
    });
  }

  finitaCompilazione(event: { info: InformativaAziendale; isBozza: boolean }): void {
    if (!event.info) return;

    this.spinnerOver.show();

    let serviceCall;

    const { info, isBozza } = event;

    const isBilancio = this.tipoModulo === 'BILANCIO';
    const isVsme = this.tipoModulo === 'REPORT_VSME';

    if (isBozza) {
      if (isBilancio) {
        serviceCall = this.informativaAziendale.putCompilaInformativaAziendaleEsternaBozza(
          this.temporaryToken,
          info,
        );
      } else if (isVsme) {
        serviceCall = this.informativaAziendale.putCompilaInformativaAziendaleEsternaBozzaVsme(
          this.temporaryToken,
          info,
        );
      }
    } else {
      if (isBilancio) {
        serviceCall = this.informativaAziendale.putCompilaInformativaAziendaleEsterna(
          this.temporaryToken,
          info,
        );
      } else if (isVsme) {
        serviceCall = this.informativaAziendale.putCompilaInformativaAziendaleEsternaVsme(
          this.temporaryToken,
          info,
        );
      }
    }

    if (serviceCall) {
      serviceCall.pipe(finalize(() => this.spinnerOver.hide())).subscribe({
        next: () => {
          if (!isBozza) {
            this.completato = true;
          }
        },
        error: (err) => {
          console.error('Errore nella compilazione:', err);
        },
      });
    } else {
      this.spinnerOver.hide();
      console.warn('Tipo modulo non gestito:', this.tipoModulo);
    }
  }
}
